export default __webpack_public_path__ + "locales/az/ConnectDialog.json?hash=e4614306c4f551fc6f68ad9ae2f3ce4c";